
import React, { useState } from 'react';
import Layout from '../components/Layout.jsx';
import './Feedback.css';
import axiosInstance from '../services/axiosInstance';

const Feedback = () => {
  const [formData, setFormData] = useState({
    feedback_title: '',
    feedback_category: 'suggestion',
    feedback_message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [submitError, setSubmitError] = useState('');

  const feedbackCategories = [
    { value: 'suggestion', label: 'Suggestion' },
    { value: 'complaint', label: 'Complaint' },
    { value: 'compliment', label: 'Compliment' },
    { value: 'feature_request', label: 'Feature Request' },
    { value: 'bug_report', label: 'Bug Report' }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.feedback_title.trim()) {
      setSubmitError('Please enter a feedback title');
      return;
    }
    
    if (!formData.feedback_message.trim()) {
      setSubmitError('Please enter your feedback message');
      return;
    }

    if (formData.feedback_message.trim().length < 10) {
      setSubmitError('Feedback message must be at least 10 characters');
      return;
    }

    setIsSubmitting(true);
    setSubmitError('');
    setSubmitMessage('');

    try {
      await axiosInstance.post('/api/feedback', formData);

      setSubmitMessage('Thank you! Your feedback has been submitted successfully.');
      setFormData({
        feedback_title: '',
        feedback_category: 'suggestion',
        feedback_message: ''
      });

      // Clear success message after 5 seconds
      setTimeout(() => setSubmitMessage(''), 5000);
    } catch (error) {
      console.error('Error submitting feedback:', error);
      setSubmitError(error.response?.data?.message || 'Failed to submit feedback. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Layout>
      <main id="main" className="main">
        <div className="container-fluid py-2">
          {/* PAGE HEADER */}
          <div className="feedback-page-header mb-2">
            <h3 className="page-title mb-1">Feedback</h3>
          </div>

          {/* FEEDBACK FORM CARD */}
          <div className="d-flex justify-content-center">
          <div className="card feedback-card" style={{ width: '100%', maxWidth: '520px' }}>
          <form onSubmit={handleSubmit} className="feedback-form">
            {/* Title Field */}
            <div className="form-group">
              <label htmlFor="feedback_title">
                Subject <span className="required">*</span>
              </label>
              <input
                type="text"
                id="feedback_title"
                name="feedback_title"
                className="form-control"
                placeholder="Brief subject of your feedback"
                value={formData.feedback_title}
                onChange={handleInputChange}
                maxLength="100"
                required
              />
              <small className="char-count">
                {formData.feedback_title.length}/100
              </small>
            </div>

            {/* Category Field */}
            <div className="form-group">
              <label htmlFor="feedback_category">
                Category <span className="required">*</span>
              </label>
              <select
                id="feedback_category"
                name="feedback_category"
                className="form-control"
                value={formData.feedback_category}
                onChange={handleInputChange}
                required
              >
                {feedbackCategories.map(cat => (
                  <option key={cat.value} value={cat.value}>
                    {cat.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Message Field */}
            <div className="form-group">
              <label htmlFor="feedback_message">
                Message <span className="required">*</span>
              </label>
              <textarea
                id="feedback_message"
                name="feedback_message"
                className="form-control"
                rows="4"
                placeholder="Please share your detailed feedback (minimum 10 characters)"
                value={formData.feedback_message}
                onChange={handleInputChange}
                minLength="10"
                maxLength="2000"
                required
              ></textarea>
              <small className="char-count">
                {formData.feedback_message.length}/2000
              </small>
            </div>

            {/* Error Message */}
            {submitError && (
              <div className="alert alert-error" role="alert">
                <i className="bi bi-exclamation-circle"></i>
                <span>{submitError}</span>
              </div>
            )}

            {/* Success Message */}
            {submitMessage && (
              <div className="alert alert-success" role="alert">
                <i className="bi bi-check-circle"></i>
                <span>{submitMessage}</span>
              </div>
            )}

            {/* Submit Button */}
            <div className="form-actions">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <span className="spinner"></span>
                    Submitting...
                  </>
                ) : (
                  <>
                    <i className="bi bi-send"></i>
                    Submit Feedback
                  </>
                )}
              </button>
            </div>
          </form>
          </div>
          </div>
        </div>
      </main>
    </Layout>
  );
};

export default Feedback;
